import React from 'react'
import DataTable from 'react-data-table-component';
import Recievedjournal from './recievedjournal';
import { FaCheckCircle, FaClock, FaSearch } from 'react-icons/fa';
import PopUpCheckList from './popUpCheckList';
import Journalrejectapprove from '../componentapprove/journalrejectapprove';
import TdsCodeCell from '../TdsCodeCell';


const columns = [
    {
        name: 'TDS code',
        sortable: true,
        selector: row => row.tdscode,
        cell: row => <TdsCodeCell tdscode={row.tdscode} revision={row.revision} />,
        grow: 0.5,
    },
    {
        name: 'Journal Type',
        selector: row => <div>
            {row.journaltype}
            <div style={{ color: 'red' }}>Create by : {row.createbyName}</div>
        </div>,
        grow: 1,
    },
    {
        name: 'customer / product',
        selector: row => <div>
            <div>: {row.customername}</div>
            <div>: {row.productname}</div>
            <div style={{ color: '#E85107' }}>: {row.productgrouptype}</div>
        </div>,
    },
    // {
    //     name: 'product name',
    //     sortable: true,
    //     selector: row => row.productname,
    // },

    {
        name: 'film code',
        selector: row => row.filmcode,
        grow: 0.5,
    },
    // {
    //     name: 'revision',
    //     selector: row => row.revision,
    //     grow: 0.3,
    // },
    // {
    //     name: 'product name',
    //     sortable: true,
    //     selector: row => row.productname,
    // },
    // {
    //     name: 'last film code',
    //     sortable: true,
    //     selector: row => row.filmcode,
    //     grow: 1,
    // },
    {
        name: 'confirm job',
        grow: 0.5,
        selector: row => <div>
            <div>{row.statusConfirm === '1' ? <label style={{ color: 'green' }}><FaCheckCircle /> Approve </label> : <label></label>}</div>
        </div>,
    },
    {
        name: 'createdate',
        selector: row => row.createdate,
        grow: 0.5,
    },
    {
        name: 'Action',
        grow: 1,
        cell: row => <div>
            {row.QuarityStatus > '0' ? <PopUpCheckList tdsCode={row.tdscode} /> : <Recievedjournal Id={row.journalId} stateflow={row.stateflow} statusflow={row.statusflow} />}

        </div>
    },

];

// ===== requireConfirm (หน้า journallistconfirmproduct) =====
// แสดงปุ่มรับงานเฉพาะงานที่ผ่าน confirm job และผ่านการตรวจสอบ QA/RD แล้ว + ปุ่มตีกลับทุกรายการ

const badgeStyle = (bg, color, border) => ({
    display: 'inline-flex', alignItems: 'center', gap: 4,
    backgroundColor: bg, color, border: `1px solid ${border}`,
    borderRadius: 12, padding: '3px 10px',
    fontSize: 11, fontWeight: 600, whiteSpace: 'nowrap',
});

function ActionRequireConfirm({ row }) {
    const emCode = sessionStorage.getItem('EmCode');
    const rejectTask = {
        journalid: row.journalId,
        emcode: emCode,
        stateflow: Number(row.stateflow),
    };

    let mainAction;
    if (row.QuarityStatus > 0) mainAction = <PopUpCheckList tdsCode={row.tdscode} />;
    else if (Number(row.statusConfirm) !== 1) mainAction = null;
    else mainAction = <Recievedjournal Id={row.journalId} stateflow={row.stateflow} statusflow={row.statusflow} />;

    return (
        <div style={{ display: 'flex', alignItems: 'center', gap: 6, flexWrap: 'wrap', padding: '6px 0' }}>
            {mainAction}
            <Journalrejectapprove newTask={rejectTask} redirectTo='/journallistconfirmproduct' variant='outline-danger' />
        </div>
    );
}

const columnsRequireConfirm = [
    {
        name: 'TDS code',
        sortable: true,
        width: '150px',
        selector: row => row.tdscode,
        cell: row => <TdsCodeCell tdscode={row.tdscode} revision={row.revision} />,
    },
    {
        name: 'วันที่',
        width: '110px',
        selector: row => row.createdate,
    },
    {
        name: 'ประเภทเอกสาร',
        grow: 1,
        cell: row => (
            <div style={{ padding: '6px 0' }}>
                <div style={{ fontWeight: 600 }}>{row.journaltype}</div>
                <div style={{ fontSize: 11, color: '#dc3545' }}>สร้างโดย : {row.createbyName}</div>
            </div>
        ),
    },
    {
        name: 'ลูกค้า / สินค้า',
        grow: 2,
        cell: row => (
            <div style={{ padding: '6px 0', lineHeight: 1.5 }}>
                <div style={{ fontWeight: 600 }}>{row.customername}</div>
                <div style={{ color: '#495057' }}>{row.productname}</div>
                {row.productgrouptype && (
                    <span style={badgeStyle('#fff4e6', '#E85107', '#ffd8a8')}>{row.productgrouptype}</span>
                )}
            </div>
        ),
    },
    {
        name: 'film code',
        width: '120px',
        selector: row => row.filmcode || '-',
    },
    {
        name: 'สถานะ',
        width: '150px',
        cell: row => (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 4, padding: '6px 0' }}>
                {Number(row.statusConfirm) === 1
                    ? <span style={badgeStyle('#d1e7dd', '#146c43', '#a3cfbb')}><FaCheckCircle size={10} /> Confirm job</span>
                    : <span style={badgeStyle('#fff4e6', '#E85107', '#ffd8a8')}><FaClock size={10} /> รอ confirm job</span>}
                {row.QuarityStatus > 0 &&
                    <span style={badgeStyle('#e7f1ff', '#0b5ed7', '#b6d4fe')}><FaSearch size={10} /> รอตรวจ QA/RD</span>}
            </div>
        ),
    },
    {
        name: 'Action',
        width: '200px',
        cell: row => <ActionRequireConfirm row={row} />,
    },
];

const customStylesRequireConfirm = {
    headRow: {
        style: {
            border: 'none',
            backgroundColor: '#f1f8f4',
            minHeight: '44px',
        },
    },
    headCells: {
        style: {
            color: '#1a7f5a',
            fontSize: '13px',
            fontWeight: 700,
        },
    },
    rows: {
        style: {
            fontSize: '13px',
            borderBottom: '1px solid #eef0f2',
        },
        highlightOnHoverStyle: {
            backgroundColor: '#f6fbf8',
            outline: 'none',
        },
    },
    pagination: {
        style: {
            border: 'none',
        },
    },
};

//tasknote

const customStyles = {
    headRow: {
        style: {
            border: 'none',
            backgroundColor: '#28B463'
        },
    },
    headCells: {
        style: {
            color: '#ffff',
            fontSize: '14px',
        },
    },
    rows: {
        highlightOnHoverStyle: {
            backgroundColor: 'rgb(230, 244, 244)',
            borderBottomColor: '#FFFFFF',
            borderRadius: '25px',
            outline: '1px solid #FFFFFF',
        },
    },
    pagination: {
        style: {
            border: 'none',
        },
    },
};


const Tablejournallistrecieved = ({ values, requireConfirm = false }) => {
    var data = values;
    return (
        <DataTable
            columns={requireConfirm ? columnsRequireConfirm : columns}
            data={data}
            // selectableRows
            pagination
            customStyles={requireConfirm ? customStylesRequireConfirm : customStyles}
            noDataComponent={<div style={{ padding: 40, color: '#6c757d' }}>ไม่พบรายการ</div>}
            highlightOnHover

        />
    )
}

export default Tablejournallistrecieved